export const GET_ADDON_PRODUCTS = 'GET_ADDON_PRODUCTS';
export const UPDATE_ADDON_PRODUCTS = 'UPDATE_ADDON_PRODUCTS';
export const SET_ADDON_PRODUCTS_LOADING = 'SET_ADDON_PRODUCTS_LOADING';

export const SHOW_EDIT_PRICE_MODAL = 'SHOW_EDIT_PRICE_MODAL';
export const SET_PRICE_EDITOR_LOADING = 'SET_PRICE_EDITOR_LOADING';
export const SET_PRICE_EDITOR_ERROR = 'SET_PRICE_EDITOR_ERROR';
export const UPDATE_ADDON_PRODUCT_PRICE = 'UPDATE_ADDON_PRODUCT_PRICE';

export const ADDITIONAL_SERVICE_DO_SHOW_LOG = 'ADDITIONAL_SERVICE_DO_SHOW_LOG';
export const ADDITIONAL_SERVICE_LOG_SET_SHOWN =
  'ADDITIONAL_SERVICE_LOG_SET_SHOWN';
export const ADDITIONAL_SERVICE_LOG_CHANGE_PAGE =
  'ADDITIONAL_SERVICE_LOG_CHANGE_PAGE';
export const ADDITIONAL_SERVICE_LOG_SET_DATA =
  'ADDITIONAL_SERVICE_LOG_SET_DATA';
export const ADDITIONAL_SERVICE_LOG_SET_IS_LOADING =
  'ADDITIONAL_SERVICE_LOG_SET_IS_LOADING';
export const ADDITIONAL_SERVICE_LOG_SET_ERRORS =
  'ADDITIONAL_SERVICE_LOG_SET_ERRORS';
